import React from "react";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";

export const Field = ({ label, children, className, hint }) => (
  <div className={cn("space-y-1.5", className)}>
    {label && (
      <Label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </Label>
    )}
    {children}
    {hint && <p className="text-[11px] text-muted-foreground">{hint}</p>}
  </div>
);

// options: array of strings OR {value,label}
export const SelectField = ({ value, onChange, options, placeholder, className }) => (
  <Select value={value ?? ""} onValueChange={onChange}>
    <SelectTrigger className={cn("h-11", className)}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {options.map((o) => {
        const val = typeof o === "string" ? o : o.value;
        const lab = typeof o === "string" ? o : o.label;
        return (
          <SelectItem key={val} value={val}>
            {lab}
          </SelectItem>
        );
      })}
    </SelectContent>
  </Select>
);
